import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import formulaService from "../services/eom-corecivic-formulary-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { selectRow, clearSelectedRow } from "../state/reducers/eomSlice";

const CreateFormula = ({ history }) => {
  const { id } = useParams();
  let { selectedRow, year } = useSelector(selectRow);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedRow?.ndc || selectedRow?.gpi || selectedRow?.drug_name) {
      setFormulary(selectedRow?.formulary);
      setDrugname(selectedRow?.drug_name);
      setGPI(selectedRow?.gpi);
    }
    return function cleanup() {
      dispatch(clearSelectedRow());
    };
  }, [selectedRow]);

  useEffect(() => {
    if (id) getFormulaDetails(id);
  }, [id]);
  const [formulary, setFormulary] = useState("");
  const [gpi, setGPI] = useState("");
  const [drug_name, setDrugname] = useState("");
  const [loading, setLoading] = useState(false);
  const getFormulaDetails = async (id) => {
    try {
      setLoading(true);
      const resp = await formulaService.getFormula(id);
      setFormulary(resp?.formulary);
      setDrugname(resp?.drug_name);
      setGPI(resp?.gpi);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while creating drug details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const onSubmit = async () => {
    try {
      if (!(gpi || drug_name) || !formulary) {
        setError(true);
        return;
      }
      let data = {};
      setLoading(true);
      data["gpi"] = gpi;
      data["drug_name"] = drug_name;
      data["formulary"] = formulary;
      if (id) {
        data["id"] = id;
        await formulaService.updateFormula(data);
      } else {
        await formulaService.createFormula(data);
      }

      if (year) {
        await history.push("/eom");
      } else {
        await history.push("/corecivic");
      }

      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [error, setError] = useState(false);
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{id ? "EDIT" : "CREATE"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Drug name
              </label>
              {!gpi && (
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              )}

              <input
                id="drug_name"
                type="text"
                placeholder="Drug name"
                value={drug_name}
                onChange={(e) => setDrugname(e.target.value)}
                className={` ${
                  error && !drug_name && !gpi ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
              {error && !drug_name && !gpi && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify drug name or GPI
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                GPI
              </label>
              {!drug_name && (
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              )}

              <input
                id="gpi"
                type="text"
                placeholder="GPI"
                value={gpi}
                onChange={(e) => setGPI(e.target.value)}
                className={` ${
                  error && !drug_name && !gpi ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && !drug_name && !gpi && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify GPI or Drug name
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Formulary
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="formulary"
                aria-label="Select formulary"
                onChange={(e) => setFormulary(e.target.value)}
                value={formulary}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              {error && !formulary && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify formulary
                </p>
              )}
            </li>

            <li className="inline-block text-sm leading-8 w-full">
              <button
                className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                aria-label="Create"
                onClick={() => onSubmit()}
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateFormula)
);
